export default __webpack_public_path__ + "static/media/flow002.df1d30bb.jpg";